import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NewsUpdatesComponent } from './news-updates.component';

@NgModule({
  declarations: [NewsUpdatesComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [NewsUpdatesComponent]
})
export class NewsUpdatesModule { }
